// Generated by uRequire v0.7.0-beta.15 target: 'dist' template: 'nodejs'
(function () {
  
var __isAMD = !!(typeof define === 'function' && define.amd),
    __isNode = (typeof exports === 'object'),
    __isWeb = !__isNode;

var Polygon = require('./polygon'),
    O = require('./ops');

module.exports = (function () {
  return function (arg) {
    var angle, center, points, radii;
    center = arg.center, radii = arg.radii;
    angle = 2 * Math.PI / radii.length;
    points = radii.map(function (r, i) {
      return O.plus(center, O.on_circle(r, i * angle));
    });
    return Polygon({
      points: points,
      closed: true
    });
  };
}).call(this);


}).call(this)


/*****************
 ** WEBPACK FOOTER
 ** ./~/paths-js/semi-regular-polygon.js
 ** module id = 1054
 ** module chunks = 0
 **/